"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * ProgramSelect component - dropdown for selecting an academic program
 */
const react_1 = require("react");
const Select_1 = require("./Select");
const LoadingSpinner_1 = require("./LoadingSpinner");
const academicProgramApi_1 = require("../helpers/academicProgramApi");
/**
 * ProgramSelect component that loads and displays academic programs
 * @param props - ProgramSelectProps
 * @returns ProgramSelect component
 */
const ProgramSelect = ({ value, onChange, tenantId, organizationId, disabled = false, required = false, error, label = 'Academic Program', }) => {
    const [programs, setPrograms] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [loadError, setLoadError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const loadPrograms = () => __awaiter(void 0, void 0, void 0, function* () {
            // Must have at least tenantId to load programs
            if (!tenantId) {
                setLoading(false);
                setLoadError('Unable to load programs: tenant information not available');
                return;
            }
            setLoading(true);
            setLoadError(null);
            try {
                // Fetch approved programs for the tenant
                let data = yield academicProgramApi_1.academicProgramApi.getApprovedPrograms(tenantId);
                // If organizationId is also provided, filter by organization
                // This matches Angular's logic: fetch by tenant, then filter by org
                if (organizationId) {
                    data = data.filter(program => program.organizationId === organizationId);
                }
                // Sort programs alphabetically by name
                data.sort((a, b) => a.name.localeCompare(b.name));
                setPrograms(data);
            }
            catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to load programs';
                setLoadError(errorMessage);
            }
            finally {
                setLoading(false);
            }
        });
        loadPrograms();
    }, [tenantId, organizationId]);
    const handleChange = (event) => {
        const selectedId = event.target.value;
        const selectedProgram = programs.find((prog) => prog.id === selectedId) || null;
        onChange(selectedId, selectedProgram);
    };
    if (loading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "program-select-loading", children: (0, jsx_runtime_1.jsx)(LoadingSpinner_1.LoadingSpinner, { size: "small", label: "Loading programs..." }) }));
    }
    if (loadError) {
        return ((0, jsx_runtime_1.jsx)(Select_1.Select, { id: "program-select", label: label, value: value, onChange: handleChange, options: [], error: loadError, disabled: true, required: required, placeholder: "Select a program" }));
    }
    // Map programs to options (already sorted alphabetically)
    const options = programs.map((prog) => ({
        value: prog.id,
        label: prog.name,
        disabled: prog.active === false,
    }));
    return ((0, jsx_runtime_1.jsx)(Select_1.Select, { id: "program-select", label: label, value: value, onChange: handleChange, options: options, error: error, disabled: disabled, required: required, placeholder: "Select a program", fullWidth: true }));
};
exports.ProgramSelect = ProgramSelect;
exports.default = exports.ProgramSelect;
